import axios from 'axios';

const axiosInstance = axios.create({
    withCredentials: true,
    timeout: 15000,
    headers: {
        'Cache-Control': 'no-cache',
        'Accept': 'application/json',
        'X-TRP-Requested-With': 'XMLHttpRequest'
    }
});

export const axiosDocumentInstance = axios.create({
    withCredentials: true,
    timeout: 60000,
    headers: {
        'Cache-Control': 'no-cache',
        'Accept': 'application/json',
        'X-TRP-Requested-With': 'XMLHttpRequest'
    }
})

export default axiosInstance;
